import type { SxProps, Theme } from '@mui/material';

export const styles = {
    grid: {
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
        gap: 2,
        mt: 1,
    } as SxProps<Theme>,
    fullWidth: { gridColumn: { md: '1 / -1' } } as SxProps<Theme>,
    inlineToggle: {
        display: 'flex',
        alignItems: 'center',
        mt: 0.5,
        fontSize: '13px',
    } as SxProps<Theme>,
    helpText: {
        fontSize: '12px',
        color: 'grey.500',
        mt: 0.25,
    } as SxProps<Theme>,
    warnText: (theme: Theme): SxProps<Theme> => ({
        fontSize: '12px',
        color: theme.palette.yellow[900],
        mb: 1,
    }),
    // The TextField helper text is absolutely positioned at bottom: -20, so
    // anything stacked under a FieldWrapper'd input needs ~24px of clearance
    // to avoid overlapping the helper line.
    checkboxBelowField: { mt: 3 } as SxProps<Theme>,
};
